import { FormCapaTabelaDePreco } from '@/models';
import {Inject} from "inversify-props";
import { TabelaDePrecoServiceAdapter } from './adapter/TabelaDePrecoServiceAdapter';

export class CreateTabelaDePrecoUseCase {
	@Inject('TabelaDePrecoServiceAdapter')
	private tabelaService!: TabelaDePrecoServiceAdapter

	create = async (tabela: FormCapaTabelaDePreco) => this.tabelaService.create(tabela)
}